import {LoginFlow, User} from '@hconnect/apiclient'
import {PlantSelect as PlantSelectComponents} from '@hconnect/common/components'
import {Env, PlantSelectOption, WhiteList} from '@hconnect/common/hproduce/types'
import {getSupportedLanguages} from '@hconnect/common/utils'
import {Shell, ShellFooter, PageContainer, CommonHeader} from '@hconnect/uikit/src/lib2'
import {useUpmPlantsContext, getPlantName} from '@hconnect/upm'
import {useTranslation} from 'react-i18next'
import {generatePath, Navigate, useLocation, useNavigate} from 'react-router'

import {routeToEvents} from '../routes'

type PlantSelectProps = {
  whiteList: WhiteList
  loginFlow: LoginFlow
  user: User
}

export const PlantSelect: React.FC<PlantSelectProps> = ({whiteList, loginFlow, user}) => {
  const {t, i18n} = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const upmPlants = useUpmPlantsContext()

  const allowedPlants = whiteList.optionsPerApp.Cockpit || []

  const plantsList: PlantSelectOption[] = allowedPlants.map(({plantId}) => {
    return {
      plantId,
      plantName: getPlantName(upmPlants, plantId),
      url: generatePath(routeToEvents, {plantId})
    }
  })

  if (plantsList.length === 1) {
    return <Navigate to={plantsList[0].url} />
  }

  return (
    <Shell
      isResponsive
      header={
        <CommonHeader
          appName="Cockpit"
          onLogout={() => void loginFlow.startLogoutProcess()}
          supportedLanguages={getSupportedLanguages(i18n)}
          upmPlants={upmPlants}
          user={{email: user.eMail || undefined, name: user.name || undefined}}
          env={process.env.REACT_APP_STAGE as Env}
          whiteList={whiteList}
          navigate={(url) => navigate(url)}
          locationPath={location.pathname}
          enableMyTasks
          closeDropdownOnLanguageSwitch
        />
      }
      footer={<ShellFooter label={t('footer.poweredBy')} />}
    >
      <PageContainer>
        <PlantSelectComponents plants={plantsList} />
      </PageContainer>
    </Shell>
  )
}
